import ClickIcon from "pages/SingleJourney/icons/ClickIcon";
import WebIcon from "pages/SingleJourney/icons/WebIcon";
import KeyboardIcon from "pages/SingleJourney/icons/KeyboardIcon";
import GroupIcon from "pages/SingleJourney/icons/GroupIcon";

const StepIcon = (props) => {
    const { action, isSelected } = props;

    switch (action) {
        case 'Click':
            return <ClickIcon fill={isSelected ? '#fff' : undefined} />
        case 'Setup':
            return <WebIcon fill={isSelected ? '#fff' : undefined} />
        case 'Keyboard':
            return <KeyboardIcon fill={isSelected ? '#fff' : undefined} />
        case 'Group':
            return <GroupIcon fill={isSelected ? '#fff' : undefined} />
        default:
            return <WebIcon fill={isSelected ? '#fff' : undefined} />
    }
}

export default StepIcon;